var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card"},[_c('router-link',{attrs:{"to":{
      name: 'album',
      params: { album: Object.keys(this.album)[0] },
    }}},[_c('div',{staticClass:"covers center",class:{ row: !_vm.load, grid: _vm.load, padding: _vm.load }},[_c('Loading',{directives:[{name:"show",rawName:"v-show",value:(!_vm.load),expression:"!load"}],attrs:{"noHeight":"","small":""}}),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.load),expression:"load"}],staticClass:"cover",style:({
          backgroundImage: `url(${Object.values(this.album)[0].category_image + _vm.getAdditionalExt})`,
        })})],1),_c('label',[_vm._v(" "+_vm._s(Object.values(this.album)[0].name)+" ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }